module.exports = __webpack_public_path__ + "img/rise.f7fc01c9.png";